import { useTranslation } from 'next-i18next';
import styles from './SelectVariantMessage.module.scss';

const SelectVariantMessage = ({
  colours,
  sizes,
  isAddress,
}: {
  colours?: number;
  sizes?: number;
  isAddress?: boolean;
}) => {
  const { t } = useTranslation('pdp');

  const selectedSizeAndColor = colours && sizes && colours > 1 && sizes > 1;
  const selectSize = colours && sizes && colours === 1 && sizes > 1;
  const selectColor = colours && sizes && colours > 1 && sizes === 1;

  return (
    <span className={styles.selectVariantMessage}>
      {selectedSizeAndColor &&
        isAddress &&
        t('product.shipping.message.new.size')}
      {selectColor && isAddress && t('product.shipping.message.new.color')}
      {selectSize && isAddress && t('product.shipping.message.new.size')}
      {selectedSizeAndColor && !isAddress && t('product.spu.message.new.size')}
      {selectColor && !isAddress && t('product.spu.message.new.color')}
      {selectSize && !isAddress && t('product.spu.message.new.size')}
    </span>
  );
};

export default SelectVariantMessage;
